<template>
  <div class="toggle-wrapper mb-3">
    <label class="label">{{ 'base.access_to_loading' | translate }}</label>
    <div class="toggle">
      <button
        :class="['toggle-btn', mode === 'percent' ? 'active' : '']"
        @click="setMode('percent')"
      >%</button>
      <button
        :class="['toggle-btn', mode === 'kg' ? 'active' : '']"
        @click="setMode('kg')"
      >{{ 'base.kg' | translate }}</button>
    </div>
    <input v-if="mode === 'kg'"
      type="number"
      min="1"
      class="value-input"
      v-model.number="tolerance_kg"
      @blur="updateKg" />

    <input v-else
      type="number"
      min="0"
      max="100"
      class="value-input"
      v-model.number="tolerance_percent"
      @blur="updatePercent" />
  </div>
</template>

<script>
export default {
  name: 'UiToggleUnit',
  props: {
    toleranceUnit: {
      type: String,
      default: 'percent'
    },
    toleranceKg: {
      type: Number,
      default: 0
    },
    tolerancePercent: {
      type: Number,
      default: 97
    },
  },
  emits: ['update'],
  data () {
    return {
      mode: this.toleranceUnit,
      tolerance_kg: this.toleranceKg,
      tolerance_percent: this.tolerancePercent,
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.mode = this.toleranceUnit
      this.tolerance_kg = this.toleranceKg
      this.tolerance_percent = this.tolerancePercent
    })
  },
  methods: {
    setMode (unit) {
      this.mode = unit
      this.emitUpdate()
    },
    updatePercent () {
      this.tolerance_percent = Number(Math.max(0, Math.min(100, this.tolerance_percent)).toFixed(2))
      this.emitUpdate()
    },
    updateKg () {
      this.tolerance_kg = Number(Math.max(0, this.tolerance_kg).toFixed(2))
      this.emitUpdate()
    },
    emitUpdate () {
      this.$emit('update', {
        tolerance_kg: this.tolerance_kg,
        tolerance_percent: this.tolerance_percent,
        tolerance_unit: this.mode
      })
    }
  }
}
</script>

  
  <style scoped>
  .toggle-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.5rem;
  }
  .toggle {
    display: flex;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    overflow: hidden;
    width: 9rem;
    min-width: 9rem;
    padding: 1px;
  }
  .toggle-btn {
    padding: 0.4rem;
    flex-basis: 50%;
    border: none;
    background: #fff;
    cursor: pointer;
    font-weight: 700;
    color: #959595;
    font-size: 1.5rem;
    border-radius:  0.5rem;

  }
  .toggle-btn.active {
    background: #36d576;
    color: white;
  }
  .value-input {
    min-width: 7rem;
    max-width: 7rem;
    padding: .5rem;
    text-align: right;
    background-color: #F4F4F4;
    font-weight: 700;
    border-bottom: 1px solid #D8D8D8;
  }
  </style>
  